import React, { useEffect, useState } from "react";
import { useLocation, useParams, Link as RouterLink, useHistory } from 'react-router-dom';
import { Button, TextField, Box, MenuItem, Container, FormControlLabel, Switch, FormGroup, Checkbox } from '@material-ui/core';
import { Title } from "react-admin";
import CreateRoundUtil from "../CreateRound/CreateRoundUtil";
import AdminUtil from "../Admin/AdminUtil";
import { BaseItemState } from "../Ticker2/Ticker2Models";
import { Operator, OperatorSetting } from "../Admin/AdminModels";
import OperatorSelect from "../Components/OperatorSelect";
import AgentUtil from "./AgentUtil";
import { Player, Agent, AgentUpdate, AgentUser, AgentUserUpdate } from "./AgentModels";
import { GenericResponse } from "../CreateRound/CreateRoundModels";
import ImagePicker, { FileUploadInfo } from "../Components/ImagePicker";
import { imageFileTypes, renderImgFromArray } from "../common/helpers/ImageHelpers";
import ImageView from "../Components/ImageView";
import { checkInput } from "../common/helpers/InputUtils";
import { ItemParams } from "../models/ItemParams";

interface EditAgentUserState {
    updateNo: number;
    item?: AgentUser;
    id: number;
    agentId: number;
    agentName: string;
    agentUserName: string;
    operatorId: string;
    profileText: string;
    admin: boolean;
    enabled: boolean;
    valid: boolean;
    agentError: string;
    agentUserNameError: string;
    profileTextError: string;
    value?: AgentUser;
    update?: AgentUserUpdate;
}

function parseFloatX(s: string) : number {
    if (!s || s.length <= 0) {
        return NaN;
    }
    var f = parseFloat(s);
    if (!isNaN(f)) {
        var s2 = f.toString();
        if (s2 === s) {
            return f;
        }
    }
    //return NaN;
    var dsep=(1/2).toLocaleString().charAt(1);
    // if (s.charAt(0) < '0' || s. )
    const decimalNumberPattern = "^-?\\d+\\" + dsep + "?\\d+$|^-?\\d+$";
    var regex = new RegExp(decimalNumberPattern);
    if (!regex.test(s)) {
        return NaN;
    }
    var tsep= (dsep === ".") ? "," : ".";
    var s2 = s.replaceAll(/\s/g, "");
    s2 = s2.replaceAll(tsep, "");
    if (dsep !== ".") {
        s2 = s2.replaceAll(dsep, ".");
    }
    f = parseFloat(s2);
    if (!isNaN(f)) {
        var s3 = f.toString();
        if (s3 === s2) {
            return f;
        }
        if (s2.length > s3.length && s2.charAt(s.length - 1) === "0" && f !== 0) {
            return f;
        }
        return NaN;
    }
    return f;
}
function getDecimalCount(d: number) {
    if (!d) {
        return 0;
    }
    if (Number.isInteger(d)) {
        return 0;
    }
    var splits = d.toString().split(".");
    if (splits.length < 2) {
        return 0;
    }
    return splits[1].length;
}
function checkState(state : EditAgentUserState) {

    var valid = true;
    var agentErr = "";
    var agentUserNameErr = "";
    var profileTextErr = "";

    if (state.agentId === 0) {
        valid = false;
        agentErr = "Required";
    } else if (state.agentName.length === 0) {
        valid = false;
        agentErr = "Agent does not exist.";
    }

    var result = checkInput(state.agentUserName, true, 1, 64);
    if (!result.valid) {
        valid = false;
        agentUserNameErr = result.message;
    }

    var result = checkInput(state.profileText, false, 0, 2000);
    if (!result.valid) {
        valid = false;
        profileTextErr = result.message;
    }


    state.valid = valid;
    state.agentError = agentErr;
    state.agentUserNameError = agentUserNameErr;
    state.profileTextError = profileTextErr;

    if (valid) {
        var item = state.item;
        var agentUser : AgentUser = {
            createdAt: item ? item.createdAt : new Date(),
            id: item ? item.id : 0,
            agentId: state.agentId,
            agentUserName: state.agentUserName,
            agentName: state.agentName,
            operatorId: state.operatorId,
            profileText: state.profileText,
            admin: state.admin,
            enabled: state.enabled
        };
        state.value = agentUser;

        var update : AgentUserUpdate | undefined = { id: agentUser.id };
        var changeCount = 0;
        if (item) {
            if (agentUser.agentUserName !== item.agentUserName) {
                update.agentUserName = agentUser.agentUserName;
                changeCount++;
            }
            if (agentUser.profileText !== item.profileText) {
                update.profileText = agentUser.profileText;
                changeCount++;
            }
            if (agentUser.admin !== item.admin) {
                update.admin = agentUser.admin;
                changeCount++;
            }
            if (agentUser.enabled !== item.enabled) {
                update.enabled = agentUser.enabled;
                changeCount++;
            }
            if (changeCount <= 0) {
                update = undefined;
            }
        } else {
            update.agentId = agentUser.agentId;
            update.agentUserName = agentUser.agentUserName;
            update.profileText = agentUser.profileText;
            update.admin = agentUser.admin;
            update.enabled = agentUser.enabled;
        }
        state.update = update;
    } else {
        state.value = undefined;
        state.update = undefined;
    }
}

function updateState(state: EditAgentUserState, item?: AgentUser, agent?: Agent) {
    state.updateNo += 1;
    state.item = item;
    if (item) {
        state.id = item.id;
        state.agentId = item.agentId;
        state.agentUserName = item.agentUserName;
        state.profileText = item.profileText ? item.profileText : "";
        state.admin = item.admin;
        state.enabled = item.enabled;
        state.agentName = item.agentName;
        state.operatorId = item.operatorId;
    } else if (agent) {
        state.agentId = agent.id;
        state.agentName = agent.name;
        state.operatorId = agent.operatorId;
    }
    checkState(state);
}

function getInitialState() : EditAgentUserState {
    var state : EditAgentUserState = {
        updateNo: 0,
        id: 0,
        agentId: 0,
        agentUserName: "",
        profileText: "",
        admin: false,
        enabled: true,
        agentName: "",
        operatorId: "",
        valid: false,
        agentError: "Not specified",
        agentUserNameError: "Not specified",
        profileTextError: "",
    };
    checkState(state);
    return state;
}

const EditAgentUser: React.FC = (props) => {
    const location = useLocation();
    const params: ItemParams  = useParams();
    const history = useHistory();    
   
    const [formState, setFormState] = useState<EditAgentUserState>(getInitialState());
    const [saveError, setSaveError] = useState<string>("");
    const [saveStatus, setSaveStatus] = useState<number>(0);
    const [initErr, setInitErr] = useState<string>("");
    const [refreshing, setRefreshing] = useState<boolean>(false);

    useEffect(() => {
        initData().then(result => {
        });
    }, [params.id, location.search]);

    const initData = async () : Promise<number> => {
        var initCount = 0;
        setInitErr("Initializing...");
        setRefreshing(true);
        try {   
            setFormState(getInitialState());
            var fs = {...formState, id: 0};
            var id : number = params.id ? parseInt(params.id) : 0;
            if (isNaN(id)) {
                id = 0;
            }
            if (id > 0) {
                fs.id = id;
                var resp = await AgentUtil.getAgentUser(id);
                if (resp.success) {
                    setInitErr("");
                    initCount++;
                } else {
                    setInitErr(`Init error: ${resp.message}`);
                    return initCount;
                }
                var agentUser = resp.item;
                if (agentUser) {
                    updateState(fs, agentUser); 
                } else {
                    setInitErr(`AgentUser '${id}' not found.`)
                }
                setFormState(fs);
                return initCount;
            }
            const searchParams = new URLSearchParams(location.search);
            var agentIdString = searchParams.get("agentId");
            var agentId : number = agentIdString ? parseInt(agentIdString) : 0;
            if (isNaN(agentId) || agentId <= 0) {
                setInitErr(`AgentId param '${agentIdString}' is invalid or is not specified.`);
                return initCount;
            }
            fs.agentId = agentId;
            var agentResp = await AgentUtil.getAgent(agentId);
            if (agentResp.success) {
                setInitErr("");
                initCount++;
            } else {
                setInitErr(`Init agent error: ${agentResp.message}`);
                return initCount;
            }
            var agent = agentResp.item;
            if (agent) {
                updateState(fs, undefined, agent); 
            } else {
                setInitErr(`AgentUser '${agentId}' not found.`)
            }
            setFormState(fs);
        } catch (error) {
            console.error("Init error.", error);
            setInitErr(`Init error: ${error}`);
        } finally {
            setRefreshing(false);
        }

        return initCount;
    }
    const handleChange = (name: string, value:any) => {
        var fs = {...formState, [name]: value};
        checkState(fs);
        setFormState(fs);
    }
    const onSave = () => {
        const METHOD_NAME = "SaveAgentUser";
        
        setSaveError("");
        setSaveStatus(0);
        if (!formState.valid) {
            setSaveError("Input is not valid");
            return;
        }
        if (!formState.update) {
            setSaveError("No changes");
            return;
        }
        setSaveStatus(1);
        AgentUtil.saveAgentUser(formState.id, formState.agentId, formState.update).then(resp => {
            setSaveStatus(0);
            if (resp.success){
                var item = resp.item;
                if (item) {
                    if (!formState.id || formState.id <= 0) {
                        history.push(`/agentUsers/${item.id}`);
                        return;
                    }
                    var fs = {...formState, id: item.id};
                    updateState(fs, item);
                    setFormState(fs);
                    return;
                } 
                setSaveError(`${METHOD_NAME} failure: AgentUser was not returned.`);

            } else {
                setSaveError(resp.message);
            }
        }).catch(error => {
            setSaveError(`${METHOD_NAME} error: ${error}`);
            setSaveStatus(0);
        });
           
    };

    var saveEnabled = false;
    var agentUser = formState.item;
    if (formState.valid && formState.update && !refreshing && saveStatus === 0) {
        saveEnabled = true;
    }
    var initErrorBox = null;
    if (initErr && initErr.length > 0) {
        initErrorBox = (<Box marginTop={3} color="red">{initErr}</Box>);
        saveEnabled = false;
    }

    var saveErrorBox = null;
    if (saveError.length > 0) {
        saveErrorBox = (<Box color="red">{saveError}</Box>);
    }


    var title = agentUser ? `Edit Agent User #${agentUser.id}` : "Create Agent User";
    var agentTitle = `${formState.agentName}`
    return (
        <Container maxWidth="xl">
            <Title title={title} />
            <Box>
                <TextField
                    label="Id"
                    name="id"
                    value={formState.id ? formState.id : "0"}
                    helperText={formState.item ? `CreatedAt: ${CreateRoundUtil.toGameDateString(formState.item.createdAt)}` : ""}
                    InputProps={{
                        readOnly: true, disableUnderline: true
                        }}
                />
            </Box>
            <Box>
                <TextField
                    label="Agent"
                    name="agentId"
                    value={formState.agentName}
                    helperText={`Id:${formState.agentId} | Operator:${formState.operatorId}`}
                    InputProps={{
                        readOnly: true, disableUnderline: true
                        }}
                />
            </Box>
            <Box marginTop={2}>
                <TextField
                    autoFocus
                    label="User name"
                    name="agentUserName"
                    value={formState.agentUserName}
                    onChange={e => handleChange("agentUserName", e.target.value)}
                    helperText={formState.agentUserNameError}
                    error={formState.agentUserNameError.length > 0}
                    style={{width:400}}
                />
            </Box>
            <Box marginTop={2}>
                <TextField
                    label="Profile text"
                    name="profileText"
                    value={formState.profileText}
                    onChange={e => handleChange("profileText", e.target.value)}
                    helperText={formState.profileTextError}
                    error={formState.profileTextError.length > 0}
                    style={{width:400}}
                    variant="outlined"
                    multiline
                    maxRows={6}
                />
            </Box>
            <Box marginTop={2}>
                <FormGroup>
                    <FormControlLabel style={{padding: 0}} control={<Checkbox checked={formState.admin} name="admin" onChange={e => handleChange("admin", e.target.checked)} style={{padding: 0}} />} label="Admin" />                  
                    <FormControlLabel control={<Checkbox checked={formState.enabled} name="enabled" onChange={e => handleChange("enabled", e.target.checked)} style={{padding: 0}} />} label="Enabled" />
                </FormGroup>
            </Box>
            {initErrorBox} 
            <Box marginTop={2}>
                <Button onClick={e => onSave()} color="primary" variant="contained" disabled={!saveEnabled}>
                    Save
                </Button>
            </Box>
            {saveErrorBox} 
            <Box>
            <Button
                    component={RouterLink}
                    color="secondary"
                    size="small"
                    style={{textTransform:"none"}}
                    to={"/agentOverview"}
                    >
                    Goto Agent Overview
                </Button>&nbsp;

            </Box>
            {/* <Box>
                <pre>{JSON.stringify(formState, undefined, 2)}</pre>

            </Box> */}
        </Container>
    );
};

export default EditAgentUser;
